import {useEffect,useRef,useState,useSyncExternalStore} from 'react';
import type {User} from '@reados/contracts';
import {api} from '../api';
import {createAuthBootstrap} from '../auth-bootstrap';

export function useAuthBootstrap(onUser:(user:User|null)=>void){
 const onUserRef=useRef(onUser);onUserRef.current=onUser;
 const [controller]=useState(()=>createAuthBootstrap({read:signal=>api.me(signal),onUser:user=>onUserRef.current(user)}));
 const state=useSyncExternalStore(controller.subscribe,controller.getSnapshot,controller.getSnapshot);
 useEffect(()=>{
  const resume=()=>{if(document.visibilityState!=='hidden'&&navigator.onLine!==false)controller.resume();};
  controller.start();window.addEventListener('online',resume);document.addEventListener('visibilitychange',resume);
  return()=>{window.removeEventListener('online',resume);document.removeEventListener('visibilitychange',resume);controller.stop();};
 },[controller]);
 return {state,retry:controller.retry,setUser:controller.setUser};
}
